import type { PayloadAction } from '@reduxjs/toolkit'

import { createSlice } from '@reduxjs/toolkit'

import type {IFile} from "../../types/file";

export interface FilesState {
  isLoading: boolean,
  error: string,
  currentPath: string,
  files: Array<IFile>
}

const initialState: FilesState = {
  isLoading: false,
  error: '',
  currentPath: '/',
  files: [],
}

export const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true
    },
    stopLoading: (state) => {
      state.isLoading = false
    },
    hasError: (state, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    setFiles: (state, action: PayloadAction<IFile[]>) => {
      state.isLoading = false
      state.files = action.payload
    },
    setPath: (state, action: PayloadAction<string>) => {
      state.isLoading = false
      state.currentPath = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const {
  startLoading,
  stopLoading,
  hasError,
  setFiles,
  setPath
} = filesSlice.actions

  export default filesSlice.reducer
